

export class GeoFenceAlertSpecificationInput implements IGeoFenceAlertSpecificationInput {
    /** The auto-generated id of the geofence master */
    geofenceId!: number;

    constructor(data?: IGeoFenceAlertSpecificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofenceId = _data["geofenceId"];
        }
    }

    static fromJS(data: any): GeoFenceAlertSpecificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeoFenceAlertSpecificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofenceId"] = this.geofenceId;
        return data; 
    }
}

export interface IGeoFenceAlertSpecificationInput {
    /** The auto-generated id of the geofence master */
    geofenceId: number;
}

